/* import __COLOCATED_TEMPLATE__ from './conversation-access-select-item-disabled.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();